var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"build views",style:(_vm.viewStyle)},[_c('container',{ref:"container",attrs:{"id":_vm.id,"option":_vm.option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }